module.exports = {"140203001":"新胜街道","140203002":"新平旺街道","140203003":"煤峪口街道","140203004":"永定庄街道","140203005":"同家梁街道","140203006":"四老沟街道","140203007":"忻州窑街道","140203008":"白洞街道","140203009":"雁崖街道","140203010":"挖金湾街道","140203011":"晋华宫街道","140203012":"马脊梁街道","140203013":"大斗沟街道","140203014":"王村街道","140203015":"姜家湾街道","140203016":"新泉路街道","140203017":"民胜街道","140203018":"口泉街道","140203019":"马口街道","140203020":"燕子山街道","140203021":"杏儿沟街道","140203022":"青磁窑街道","140203023":"平泉路街道","140203024":"四台沟街道","140203025":"和顺街道","140203026":"和瑞街道","140203027":"平盛路街道","140203028":"清泉街街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140203.json
// module id = 271
// module chunks = 0